import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { AuthenticationService } from '../../../services/auth-service';
import { UserAvatarService } from '../../../services/user-avatar-service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'file-upload',
    template: '<input type="file" [multiple]="multiple" #fileInput>'
})
export class FileUploadComponent {
    @Input() multiple: boolean = false;
    @ViewChild('fileInput') inputEl: ElementRef;

    constructor(private http: Http,
                private authService: AuthenticationService,
                private avatarService: UserAvatarService) {}

    upload() {
        const url = environment.API_URL + '/api/user/upload-avatar/';

        let inputEl: HTMLInputElement = this.inputEl.nativeElement;
        let fileCount: number = inputEl.files.length;
        let formData = new FormData();
        if (fileCount > 0) { // a file was selected
            let headers = new Headers();
            headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
            for (let i = 0; i < fileCount; i++) {
                formData.append('file[]', inputEl.files.item(i), localStorage.getItem('userId') + '.png');
                console.log(inputEl);

            }
            this.http.post(url, formData, {
                headers: headers
            })
            .subscribe( (data:any) => {
                console.log(data);

                // notify to the interested components that the avatar has changed
                this.avatarService.setAvatar(data._body);
            });
        }
    }

    click(){
        this.inputEl.nativeElement.click();
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/file-upload/file-upload-component.component.ts